import Modal from "./modal";

export default class AjaxForm {
	constructor(form) {
        this.form = form;
        this.form.addEventListener('submit', e => {
            e.preventDefault();
            this.submit();
        })
    }

    submit() {
        this.resetAlerts();

        const form = this.form;
        const formData = new FormData(this.form);
        const entries = formData.entries();
        const data = Object.fromEntries(entries);
        const submitBtn = this.form.querySelector('button');

        submitBtn.disabled = true;

        axios.post(this.form.action, data)
        .then(function (response) {
            submitBtn.disabled = false;
            const data = response.data;
            if (data) {
                const successHtml = `<div data-feedback class="success_feedback">${data.success}</div>`;
                form.insertAdjacentHTML('afterbegin', successHtml);
                if ('replacementHtml' in data) {
                    document.querySelector(data.replacementHtml.target).innerHTML = data.replacementHtml.html;
                    new Modal();
                }
            }
        })
        .catch(function (error) {
            submitBtn.disabled = false;
            const errors = error.response.data.errors;
            for (const [key, values] of Object.entries(errors)) {
                let errorHtml = '';
                values.forEach(value => {
                    errorHtml += `<span data-feedback class="invalid_feedback" role="alert">
                        ${value}
                    </span>`;
                });
                form.querySelector(`[name="${key}"]`).insertAdjacentHTML('afterend', errorHtml);
            }
        });
    }

    resetAlerts() {
        const alerts = this.form.querySelectorAll('[data-feedback]');
        alerts.forEach(element => {
            element.remove();
        });
    }
}